module.exports = __webpack_public_path__ + "static/img/winter_dangguiPic.d823108f.png";